// extracted by mini-css-extract-plugin
module.exports = {"title":"BackSection_title__3Rrt-","arrow":"BackSection_arrow__1P5GW"};